import React, { useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import confetti from "canvas-confetti";
import { useNavigate, useLocation } from "react-router-dom";

function PopupPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { invoiceNo } = location.state || {}; // receive invoice number
  const printReceipt = location.state?.printReceipt; // optional function ref
  const showPopup = true;

  useEffect(() => {
    if (showPopup) {
      // 🎉 Confetti burst effect
      const duration = 2000;
      const end = Date.now() + duration;
      (function frame() {
        confetti({
          particleCount: 3,
          angle: 60,
          spread: 55,
          origin: { x: 0 },
          colors: ["#bb0000", "#ffffff", "#00ccff", "#ff69b4", "#00ff99"],
        });
        confetti({
          particleCount: 3,
          angle: 120,
          spread: 55,
          origin: { x: 1 },
          colors: ["#bb0000", "#ffffff", "#00ccff", "#ff69b4", "#00ff99"],
        });
        if (Date.now() < end) requestAnimationFrame(frame);
      })();
    }
  }, [showPopup]);

  const handleClose = () => {
    localStorage.removeItem("cart");
    localStorage.removeItem("orderType");
    localStorage.removeItem("custid");
    localStorage.removeItem("userPhone");
    navigate("/");
  };

  useEffect(() => {
  if (showPopup) {
    const timer = setTimeout(() => {
      handleClose();
    }, 10000);

    return () => clearTimeout(timer);
  }
}, [showPopup]);

  return (
    <AnimatePresence>
      {showPopup && (
        <motion.div
          className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <motion.div
            className="w-full max-w-3xl bg-white rounded-3xl shadow-2xl p-20 text-center min-h-[700px]"
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.8, opacity: 0 }}
            transition={{ type: "spring", stiffness: 300, damping: 25 }}
          >
            {/* ✅ Animated Tick */}
            <motion.div
              className="relative w-40 h-40 mx-auto mb-10 flex items-center justify-center"
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              transition={{ delay: 0.2, type: "spring", stiffness: 300 }}
            >
              <motion.div
                className="absolute inset-0 rounded-full bg-green-200"
                initial={{ scale: 0.8, opacity: 0.6 }}
                animate={{ scale: [1, 1.4, 1], opacity: [0.6, 0, 0.6] }}
                transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
              />
              <motion.div
                className="relative w-36 h-36 bg-green-100 rounded-full flex items-center justify-center"
                initial={{ scale: 0 }}
                animate={{ scale: 1 }}
                transition={{ type: "spring", stiffness: 250, damping: 20 }}
              >
                <svg
                  className="w-20 h-20 text-green-600"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={3}
                  viewBox="0 0 24 24"
                >
                  <motion.path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M5 13l4 4L19 7"
                    initial={{ pathLength: 0 }}
                    animate={{ pathLength: 1 }}
                    transition={{
                      duration: 0.9,
                      ease: "easeInOut",
                      delay: 0.3,
                    }}
                  />
                </svg>
              </motion.div>
            </motion.div>

            <h2 className="text-4xl font-bold text-gray-800 mb-7">
              Order Success!
            </h2>

            <div className="flex items-center justify-center mb-7">
              <div className="flex-grow max-w-[180px] h-[2px] bg-gradient-to-r from-green-300 to-pink-300"></div>
              <p className="text-gray-500 text-l mx-4 italic">Invoice Number</p>
              <div className="flex-grow max-w-[180px] h-[2px] bg-gradient-to-r from-pink-300 to-green-300"></div>
            </div>

            <p className="text-4xl font-bold text-gray-900 mb-7">
              #{invoiceNo}
            </p>

            <p className="text-gray-700 italic text-xl mb-10">
              “Grateful for your visit — come back soon”
            </p>

            <div className="flex justify-center space-x-8">
              <button
                onClick={handleClose}
                className="px-8 py-4 bg-gradient-to-r from-emerald-500 to-green-600 text-white rounded-2xl hover:from-emerald-600 hover:to-green-700 transition text-xl shadow-md font-semibold"
              >
                Back
              </button>
              {/* <button
                onClick={printReceipt}
                className="px-8 py-4 bg-gradient-to-r from-rose-500 to-red-600 text-white rounded-2xl hover:from-rose-600 hover:to-red-700 transition text-xl shadow-md font-semibold flex items-center gap-2"
              >
                🖨️ Receipt
              </button> */}
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}

export default PopupPage;
